import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3822fc0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-title"
}
const _hoisted_2 = {
  key: 0,
  class: "relative-position",
  style: {"min-height":"200px"}
}
const _hoisted_3 = { class: "absolute-center" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "page-section-title" }
const _hoisted_6 = {
  class: "page-heading q-mb-xl",
  style: {"font-size":"14px","white-space":"break-spaces"}
}
const _hoisted_7 = {
  class: "q-mx-auto",
  style: {"max-width":"600px"}
}
const _hoisted_8 = { class: "sheet-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sheet-content__title" }, "ご回答者の情報を入力して下さい。", -1))
const _hoisted_10 = { class: "sheet-content__label" }
const _hoisted_11 = { class: "sheet-content__input" }
const _hoisted_12 = { class: "q-mb-xl" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "q-ma-none text-caption",
  style: {"padding-left":"7px","margin-top":"-5px"}
}, " ※個人情報を保存しておくと、次回の回答時に個人情報が入力済の状態でご回答いただけます。 ", -1))
const _hoisted_14 = { class: "sheet-content" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "sheet-content__label" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "sheet-content__input" }
const _hoisted_19 = { class: "sheet-content__label" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" その他、連絡事項があればご記入ください。 ")
const _hoisted_21 = { class: "sheet-content__input" }
const _hoisted_22 = { class: "row justify-center q-my-lg" }

import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAsyncTask } from 'vue-concurrency'
import dayjs from 'dayjs'
import { useMeta } from 'quasar'
import api from '@/api'
import SheetQuestion from '@/components/sheet/question/index.vue'
import SheetPersonal from '@/components/sheet/personal/index.vue'
import { useErrorStore, useUserStore } from '@/stores'
import { Book, Sheet } from '@/models'
import { swalError, swalConfirm } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const errorStore = useErrorStore()
const userStore = useUserStore()

const isSavePersonalData = ref(false)

/** Sheetの固有ID */
const sheetHash = computed(() => route.query.cd as string)

/* Bookデータ */
const book = ref(new Book())

/* Sheetデータ */
const sheet = ref(
  new Sheet({
    sheetHash: sheetHash.value,
  }),
)

const task = useAsyncTask(async () => {
  return api.sheet
    .get({ cd: sheetHash.value })
    .then(data => {
      // Bookデータを保持
      book.value = data.book
      // Formデータを構築
      sheet.value.personalData = Object.fromEntries(Object.keys(data.book.personalAttr).map(key => [key, '']))
      if ('questionDate' in sheet.value.personalData) {
        sheet.value.personalData.questionDate = dayjs().format('YYYY-MM-DD')
      }
      sheet.value.answers = Array(data.book.questions.length).fill(null)

      // 事前に用意された回答データ
      sheet.value.questions = data.sheet.questions
      // 事前に用意された回答がある場合、回答データにセットする
      sheet.value.questions.forEach((data, i) => {
        if (data !== null) {
          sheet.value.answers[i] = data
        }
      })

      // 個人情報の保存済の場合
      if (localStorage.getItem('questionName')) {
        isSavePersonalData.value = true
        setPersonalData()
      }
    })
    .catch(errorStore?.go)
}).drop()

task.perform()

/** 送信する */
function submit() {
  swalConfirm.fire({ text: '回答を送信します。よろしいですか？' }).then(result => {
    api.sheet
      .set(sheet.value)
      .then(res => {
        /* 「情報を端末に保存する」にチェックが入っている時 */
        if (isSavePersonalData.value) {
          Object.entries(sheet.value.personalData).forEach(([key, value], index) => {
            if (sheet.value.personalData[key] !== '' && key !== 'questionDate') {
              localStorage.setItem(`${key}`, value)
            }
          })
        } else {
          /* 「情報を端末に保存する」チェックを外している時 */
          Object.entries(sheet.value.personalData).forEach(([key, value], index) => {
            if (key !== 'questionDate') {
              localStorage.removeItem(`${key}`)
            }
          })
        }
        if (result.isConfirmed) {
            router.push({ path: 'sheet_completed', query: { cd: res.answerHash } })
        }
      })
      .catch(err => {
        swalError.fire({ text: err ?? '送信できませんでした' })
      })
  })
}

/* localStrageに保存済の個人情報を回答者の情報にセット */
function setPersonalData() {
  Object.entries(book.value.personalAttr).forEach(([key, value], index) => {
    if (key !== 'questionDate') {
      sheet.value.personalData[key] =
        localStorage.getItem(`${key}`) === null ? '' : (localStorage.getItem(`${key}`) as string)
    }
  })
}

useMeta(() => ({
  title: book.value.url.ogp_title,
  titleTemplate: title => `${title} - ${book.value.url.ogp_site_name}`,

  meta: {
    title: { name: 'title', content: book.value.url.ogp_title },
    description: { name: 'description', content: book.value.url.ogp_description },

    // Open Graph
    ogUrl: { property: 'og:url', content: book.value.url.ogp_url },
    ogType: { property: 'og:type', content: book.value.url.ogp_type },
    ogTitle: { property: 'og:title', content: book.value.url.ogp_title },
    ogDescription: { property: 'og:description', content: book.value.url.ogp_description },
    ogSiteName: { property: 'og:site_name', content: book.value.url.ogp_site_name },
    ogImage: { property: 'og:image', content: book.value.url.ogp_image },

    // Twitter
    twitterCard: { property: 'twitter:card', content: 'summary_large_image' },
    twitterUrl: { property: 'twitter:url', content: book.value.url.ogp_url },
    twitterTitle: { property: 'twitter:title', content: book.value.url.ogp_title },
    twitterDescription: { property: 'twitter:description', content: book.value.url.ogp_description },
    twitterImage: { property: 'twitter:image', content: book.value.url.ogp_image },
  },
}))

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(userStore).data)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "チェックシート"))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(task).isRunning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_spinner, {
                  showing: "",
                  color: "grey",
                  size: "100px",
                  thickness: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$q.screen.lt.sm ? '' : 'q-px-lg')
              }, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(book.value.bookName), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(book.value.bookNote), 1)
              ], 2),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("section", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.personalAttr, (data, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `data_${key}`
                      }, [
                        (data.display)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_q_badge, _mergeProps(
                          data.required ? { label: '必須', color: 'negative' } : { label: '任意', color: 'primary' }
                        , { class: "q-mr-xs" }), null, 16),
                                _createElementVNode("span", null, _toDisplayString(data.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(SheetPersonal, _mergeProps(data, {
                                  modelValue: sheet.value.personalData[key],
                                  "onUpdate:modelValue": ($event: any) => ((sheet.value.personalData[key]) = $event)
                                }), null, 16, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_q_checkbox, {
                      size: "md",
                      modelValue: isSavePersonalData.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSavePersonalData).value = $event)),
                      label: "上記情報を端末に保存する"
                    }, null, 8, ["modelValue"]),
                    _hoisted_13
                  ])
                ]),
                _createElementVNode("section", null, [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.questions, (question, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `question_${i}`
                      }, [
                        (question.type === 'lbl')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "sheet-content__title",
                              innerHTML: question.question
                            }, null, 8, _hoisted_15))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_q_badge, _mergeProps(
                          question.required ? { label: '必須', color: 'negative' } : { label: '任意', color: 'primary' }
                        , { class: "q-mr-xs" }), null, 16),
                                _createElementVNode("span", {
                                  innerHTML: question.question
                                }, null, 8, _hoisted_17)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(SheetQuestion, _mergeProps(question, {
                                  modelValue: sheet.value.answers[i],
                                  "onUpdate:modelValue": ($event: any) => ((sheet.value.answers[i]) = $event)
                                }), null, 16, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ], 64))
                      ], 64))
                    }), 128)),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_q_badge, {
                        label: "任意",
                        color: "primary"
                      }),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_q_input, {
                          type: "textarea",
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                          modelValue: sheet.value.sheetNote,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sheet.value.sheetNote) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_q_btn, {
                    style: {"max-width":"357px","width":"100%","height":"46px"},
                    unelevated: "",
                    color: "primary",
                    label: "回答を完了する",
                    onClick: submit
                  })
                ])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})